import api from '../utils/api';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StaffHomePage from './StaffHomePage';

const TILE = {
  staff:     ['#6B1A45', '#4B002B', '#3A0121'],
  tasks:     ['#2A7E62', '#175E48', '#0E4634'],
  payroll:   ['#C69335', '#A87A1F', '#8A6212'],
  pastures:  ['#54759A', '#3E5C7E', '#2E4763'],
  trailers:  ['#4E6E8E', '#3D5A80', '#2C4763'],
  supplies:  ['#52102F', '#33001D', '#240013'],
  documents: ['#A17A4A', '#8A6136', '#6E4C26'],
  members:   ['#BC4A70', '#A03457', '#822342'],
  lessons:   ['#2D7A4F', '#1E5435', '#143D26'],
};

const _sv = (paths) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths}</svg>
);
const ICONS = {
  staff: _sv(<><circle cx="9" cy="7" r="3"/><path d="M3 20c0-3.5 2.5-5.5 6-5.5s6 2 6 5.5"/><circle cx="17" cy="8" r="2.5"/><path d="M16.5 14.6c2.8.3 4.5 2 4.5 4.9"/></>),
  tasks: _sv(<><rect x="4" y="4" width="16" height="17" rx="2"/><path d="M8 9l2 2 3.5-3.5M8 15.5h8M8 18.5h5"/></>),
  pastures: _sv(<><path d="M4 21V9l4-3 4 3v12M4 13h8"/><path d="M15 21v-7M19 21v-7M15 17h4M12 21h10"/></>),
  trailers: _sv(<><rect x="2" y="8" width="15" height="8" rx="1"/><path d="M17 12h5M20 12v2"/><circle cx="7" cy="18" r="2"/><circle cx="13" cy="18" r="2"/><path d="M5 8V6h9v2"/></>),
  supplies: _sv(<><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/></>),
  documents: _sv(<><path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z"/><path d="M14 2v5h5"/><path d="M9 13h6M9 17h6"/></>),
  members: _sv(<><path d="M3 7l9 6 9-6"/><rect x="3" y="5" width="18" height="14" rx="2"/></>),
  payroll: _sv(<><rect x="3" y="7" width="18" height="11" rx="2"/><circle cx="12" cy="12.5" r="2.5"/><path d="M6.5 10.5h.01M17.5 15h.01"/></>),
  gear: _sv(<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></>),
  clock: _sv(<><circle cx="12" cy="12" r="8"/><path d="M12 8v4l2.5 2.5"/></>),
  lessons: _sv(<><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/><path d="M9 15l2 2 4-4"/></>),
  homeplus: _sv(<><path d="M4 11l8-7 8 7"/><path d="M6 10v10h12V10"/><path d="M12 13v5M9.5 15.5h5"/></>),
};

const Card = ({ tile, title, sub, subColor, onClick }) => {
  const c = TILE[tile];
  return (
    <button className="card" style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', border: '1px solid var(--border-color)', textAlign: 'left', padding: '11px 13px', marginBottom: 8 }} onClick={onClick}>
      <span style={{ width: 40, height: 40, borderRadius: 11, flex: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F5EBDD', background: 'linear-gradient(165deg, ' + c[0] + ' 0%, ' + c[1] + ' 55%, ' + c[2] + ' 100%)', boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.35), inset 0 -2px 3px rgba(0,0,0,0.35), 0 2px 4px rgba(0,0,0,0.22)' }}>{ICONS[tile]}</span>
      <span style={{ flex: 1 }}>
        <span style={{ display: 'block', fontSize: 14, fontWeight: 600 }}>{title}</span>
        <span style={{ display: 'block', fontSize: 12, color: subColor || 'var(--text-secondary)' }}>{sub}</span>
      </span>
      <span style={{ color: '#A97B4F', fontSize: 20 }}>&#8250;</span>
    </button>
  );
};

function isBarnOwner() {
  try {
    const u = JSON.parse(localStorage.getItem('cr_user') || '{}');
    const bag = [u.primary_role, u.account_type, u.roles, u.role,
      u.user && u.user.primary_role, u.user && u.user.account_type, u.user && u.user.roles]
      .filter(Boolean).join(' ');
    return bag.includes('barn_owner') || bag.includes('platform_admin');
  } catch (e) { return false; }
}

function parseCompliance(data) {
  try {
    if (Array.isArray(data)) {
      const total = data.length;
      const signed = data.filter(r => {
        const s = ((r.status || r.state || '') + (r.signed_at ? ' signed' : '')).toLowerCase();
        return s.includes('sign') || s.includes('complete') || s.includes('acknowledg') || s.includes('accept');
      }).length;
      return total ? { total, signed } : null;
    }
    if (data && (data.signed || data.pending || data.records)) {
      if (data.records) return parseCompliance(data.records);
      const signed = (data.signed || []).length;
      const total = signed + (data.pending || []).length;
      return total ? { total, signed } : null;
    }
  } catch (e) {}
  return null;
}

const BarnHubView = ({ org }) => {
  const navigate = useNavigate();
  const oid = org && org.id;
  const [docSub, setDocSub] = useState({ text: 'Agreements, releases, barn rules', warn: false });
  useEffect(() => {
    if (!oid) return;
    let ok = true;
    api.get(`/organizations/${oid}/documents`)
      .then(async r => {
        const list = Array.isArray(r.data) ? r.data : (r.data.documents || []);
        if (!ok) return;
        if (list.length === 0) { setDocSub({ text: 'Upload your boarding agreement', warn: false }); return; }
        let outstanding = 0, known = false;
        await Promise.all(list.slice(0, 8).map(async d => {
          try {
            const c = await api.get(`/organizations/${oid}/documents/${d.id}/compliance`);
            const p = parseCompliance(c.data);
            if (p) { known = true; outstanding += (p.total - p.signed); }
          } catch (e) {}
        }));
        if (!ok) return;
        if (known && outstanding > 0) setDocSub({ text: `${list.length} document${list.length !== 1 ? 's' : ''} \u00b7 ${outstanding} awaiting signatures`, warn: true });
        else if (known) setDocSub({ text: `${list.length} document${list.length !== 1 ? 's' : ''} \u00b7 all signed \u2713`, warn: false });
        else setDocSub({ text: `${list.length} document${list.length !== 1 ? 's' : ''}`, warn: false });
      })
      .catch(() => {});
    return () => { ok = false; };
  }, [oid]);
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 90 }}>
      <div className="top-bar" style={{ padding: '18px 16px 16px', display: 'flex', alignItems: 'center' }}>
        {org && org.logo_url && <img src={org.logo_url} alt="" style={{ width: 42, height: 42, borderRadius: 10, objectFit: 'cover', marginRight: 12, border: '1.5px solid rgba(255,255,255,0.35)' }} />}
        <div>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', margin: 0, fontWeight: 600 }}>Barn{org && org.location ? ` \u00b7 ${org.location}` : ''}</p>
          <h1 style={{ color: 'white', fontSize: 24, margin: '3px 0 0' }}>{org ? org.name : 'Your barn'}</h1>
        </div>
        <button aria-label="Barn profile" onClick={() => navigate('/barn-profile')} style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.14)', border: 'none', borderRadius: 10, width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F1EAE0', cursor: 'pointer' }}>{ICONS.gear}</button>
      </div>
      <div className="page-content">
        <Card tile="staff" title="Manage staff" sub="Time cards, shifts, edits" onClick={() => navigate('/staff-work')} />
        <Card tile="payroll" title="Payroll" sub="Who's on the clock, week totals, export" onClick={() => navigate('/payroll')} />
        <Card tile="tasks" title="Set up tasks" sub="Daily chores, assignments, checkoffs" onClick={() => navigate('/staff-work')} />
        <Card tile="pastures" title="Arrange your pastures" sub="Fields, capacity, turnout groups" onClick={() => navigate('/staff-work')} />
        <Card tile="trailers" title="Trailers" sub="Maintenance schedule and service log" onClick={() => oid && navigate(`/trailers?org=${oid}`)} />
        <Card tile="lessons" title="Lessons &amp; booking" sub="Trainers, open times, requests" onClick={() => navigate('/calendar-booking')} />
        <Card tile="staff" title="Assign horses" sub="Choose which horses each staff member handles" onClick={() => oid && navigate(`/assign-horses/${oid}`)} />
        <Card tile="supplies" title="Order supplies" sub="Track levels, reorder from the store" onClick={() => navigate('/supplies')} />
        <Card tile="documents" title="Documents" sub={docSub.text} subColor={docSub.warn ? '#B4552E' : undefined} onClick={() => oid && navigate(`/organizations/${oid}/documents`)} />
        <Card tile="members" title="Members and invites" sub={org && org.invite_code ? `Boarders \u00b7 invite code ${org.invite_code}` : 'Boarders, invites, roles'} onClick={() => oid && navigate(`/organizations/${oid}`)} />
        <button className="btn btn-full" style={{ background: '#F1EAE0', color: '#4B002B', border: 'none', borderRadius: 12, padding: '11px', fontWeight: 600, fontSize: 13, marginTop: 4 }} onClick={() => navigate('/staff-work')}>
          <span style={{ verticalAlign: 'middle', display: 'inline-flex', marginRight: 6 }}>{ICONS.clock}</span>
          <span style={{ verticalAlign: 'middle' }}>{'My shift \u2014 clock in'}</span>
        </button>
      </div>
    </div>
  );
};

const MemberBarnView = ({ org }) => {
  const navigate = useNavigate();
  const oid = org && org.id;
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 90 }}>
      <div className="top-bar" style={{ padding: '18px 16px 16px', display: 'flex', alignItems: 'center' }}>
        {org && org.logo_url && <img src={org.logo_url} alt="" style={{ width: 42, height: 42, borderRadius: 10, objectFit: 'cover', marginRight: 12, border: '1.5px solid rgba(255,255,255,0.35)' }} />}
        <div>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', margin: 0, fontWeight: 600 }}>Barn{org && org.location ? ` \u00b7 ${org.location}` : ''}</p>
          <h1 style={{ color: 'white', fontSize: 24, margin: '3px 0 0' }}>{org ? org.name : 'Your barn'}</h1>
        </div>
      </div>
      <div className="page-content">
        <Card tile="lessons" title="Lessons &amp; booking" sub="Book with your barn's trainers" onClick={() => navigate('/calendar-booking')} />
        <Card tile="documents" title="Barn info &amp; documents" sub="Contacts, releases, signatures" onClick={() => oid && navigate(`/organizations/${oid}`)} />
      </div>
    </div>
  );
};

const SetupBarnView = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 90 }}>
      <div className="top-bar" style={{ padding: '18px 16px 16px' }}>
        <h1 style={{ color: 'white', fontSize: 22, margin: 0 }}>Your barn</h1>
      </div>
      <div className="page-content" style={{ textAlign: 'center', paddingTop: 40 }}>
        <span style={{ width: 56, height: 56, borderRadius: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#F5EBDD', background: 'linear-gradient(165deg, #6B1A45 0%, #4B002B 55%, #3A0121 100%)', boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.35), inset 0 -2px 3px rgba(0,0,0,0.35), 0 2px 4px rgba(0,0,0,0.22)', marginBottom: 14 }}>{ICONS.homeplus}</span>
        <h2 style={{ fontSize: 21, color: '#4B002B', margin: '0 0 8px' }}>Set up your barn</h2>
        <p style={{ fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.55, margin: '0 0 18px' }}>Name it, add your pastures and staff, upload your boarding agreement {'\u2014'} and run the whole thing from here.</p>
        <button className="btn btn-primary btn-full" style={{ borderRadius: 12, padding: 13 }} onClick={() => navigate('/organizations')}>+ Create your barn</button>
        <p style={{ fontSize: 12.5, color: '#A97B4F', marginTop: 12, cursor: 'pointer', fontWeight: 600 }} onClick={() => navigate('/organizations')}>Boarding somewhere? Join with a code instead</p>
      </div>
    </div>
  );
};

const BarnHub = () => {
  const owner = isBarnOwner();
  const [org, setOrg] = useState(undefined);
  const [myRole, setMyRole] = useState('');
  useEffect(() => {
    let ok = true;
    const run = async () => {
      for (const ep of ['/organizations/mine', '/organizations', '/memberships/mine', '/staff/organizations']) {
        try {
          const r = await api.get(ep);
          const list = Array.isArray(r.data) ? r.data : (r.data.organizations || r.data.orgs || []);
          if (list.length) {
            const managed = list.find(o => o.my_role === 'manager' || o.role === 'manager') || list[0];
            if (ok) { setOrg(managed.organization || managed); setMyRole(managed.my_role || managed.role || ''); }
            return;
          }
        } catch (e) {}
      }
      if (ok) setOrg(null);
    };
    run();
    return () => { ok = false; };
  }, [owner]);
  if (org === undefined) return <div className="loading-screen"><div className="spinner"></div></div>;
  let meId = null;
  let isPlatformAdmin = false;
  try {
    const u = JSON.parse(localStorage.getItem('cr_user') || '{}');
    meId = u.id || (u.user && u.user.id) || null;
    const bag = [u.roles, u.role, u.primary_role, u.user && u.user.roles].filter(Boolean).join(' ');
    isPlatformAdmin = bag.includes('platform_admin');
  } catch (e) {}
  const controlsOrg = org && meId && org.controller_id === meId;
  if (myRole === 'manager' || controlsOrg || (isPlatformAdmin && org)) {
    return <BarnHubView org={org} />;
  }
  if (org === null) return owner ? <SetupBarnView /> : <StaffHomePage />;
  if (['staff', 'trainer'].includes(myRole)) return <StaffHomePage />;
  if (org) return <MemberBarnView org={org} />;
  return <StaffHomePage />;
};

export default BarnHub;
